import { render, staticRenderFns } from "./commonbottom.vue?vue&type=template&id=751f88cc&"
import script from "./commonbottom.vue?vue&type=script&lang=js&"
export * from "./commonbottom.vue?vue&type=script&lang=js&"
import style0 from "./commonbottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports